export const HOME_PAGE_URL = '/';
export const LOGIN_PAGE_URL = '/login';
export const VESSEL_PICTURES_PAGE_URL = '/vessel-pictures';
export const CITIES_PAGE_URL = '/cities';
export const VESSEL_PICTURES_FAVORITES_PAGE_URL = '/vessel-pictures/favorites';
export const VESSEL_PICTURES_ALL_PAGE_URL = '/vessel-pictures/pictures';
export const NOT_FOUND_PAGE_URL = '/404';
